export const ANALYTICS_CUSTOM_GET = 'ANALYTICS_CUSTOM_GET';
export const ANALYTICS_CUSTOM_GET_SUCCESS = 'ANALYTICS_CUSTOM_GET_SUCCESS';
export const ANALYTICS_CUSTOM_GET_FAIL = 'ANALYTICS_CUSTOM_GET_FAIL';

export const ANALYTICS_CUSTOM_GOAL_REMOVE = 'ANALYTICS_CUSTOM_GOAL_REMOVE';
export const ANALYTICS_CUSTOM_GOAL_ADD = 'ANALYTICS_CUSTOM_GOAL_ADD';

export const ANALYTICS_CUSTOM_CLEAR = 'ANALYTICS_CUSTOM_CLEAR';
